import React from "react";
import { useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useSelector } from "react-redux";
import { weatherCtx } from "../../utils/hooks/mollierWeatherContext";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const ProcessChanges = (props) => {
  const { t } = useTranslation();
  const summerPoints = useSelector((state) => state.processPoint.summerPoints);

  const winterPoints = useSelector((state) => state.winterPoints.winterPoints);
  const theme = useTheme();

  const { summerWeather, setSummerWeather } = useContext(weatherCtx);

  //  const rows = summerWeather ? summerPoints : winterPoints;
  const rows = summerWeather
    ? summerPoints.length >= 3 &&
      (summerPoints[2].process === 30 ||
        summerPoints[1].process === "DLL point")
      ? summerPoints
      : summerPoints.filter((item) => item.id != 1)
    : winterPoints.length >= 3 &&
      (winterPoints[2].process === 30 ||
        summerPoints[1].process === "DLL point")
    ? winterPoints
    : winterPoints.filter((item) => item.id != 1);

  return (
    <TableContainer
      id="processTable"
      //component={Paper}
      sx={{
        width: "100%",
        marginLeft: "0px",
        marginBottom: "50px",
        border: "1px solid grey",
      }}
    >
      <Table aria-label="simple table" sx={{ marginTop: 0 }}>
        <TableHead
          sx={{
            borderBottom: "1px solid grey",
            ".MuiTableRow-head": {
              backgroundColor: theme.palette.secondary.main,
            },
          }}
        >
          <TableRow>
            <TableCell align="left"></TableCell>
            <TableCell align="left">{t("mollier.tempDry")} (°C)</TableCell>
            <TableCell align="left">{t("mollier.relHum")} (%)</TableCell>
            <TableCell align="left">{t("mollier.absHum")} (g/kg)</TableCell>
            <TableCell align="left">{t("mollier.enthalpy")} (kJ/kg)</TableCell>
            <TableCell align="left">
              {t("mollier.density")} (kg/m<sup>3</sup>)
            </TableCell>
            <TableCell align="left">{t("mollier.tempWet")} (°C)</TableCell>
            <TableCell align="left">
              {t("mollier.airFlow")} (m<sup>3</sup>/h)
            </TableCell>
            <TableCell align="left">
              {t("mollier.realFlow")} (m<sup>3</sup>/h)
            </TableCell>
            <TableCell align="left">{t("mollier.massFlow")} (kg/h)</TableCell>
            <TableCell align="left">Delta P (kW)</TableCell>
            {!props.DBMollier && (
              <TableCell align="left">
                {t("mollier.amountOfWater")} (kg/h)
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={row.name}
              //sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.temperatureDryBulb}</TableCell>
              <TableCell>{row.relativeHumidity}</TableCell>
              <TableCell>{row.absoluteHumidity}</TableCell>
              <TableCell>{row.enthalpy}</TableCell>
              <TableCell>{row.airDensity}</TableCell>
              <TableCell>{row.temperatureWetBulb}</TableCell>
              <TableCell>{row.airFlowHours}</TableCell>
              <TableCell>{row.realFlow}</TableCell>
              <TableCell>{row.massFlow}</TableCell>
              <TableCell>{row.usedPower}</TableCell>
              {!props.DBMollier && <TableCell>{row.usedWater}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProcessChanges;
